import { Component, OnInit } from '@angular/core';
import { ApplyButtonComponent } from '../../../shared/components/apply-button/apply-button.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { VideoModalComponent } from '../../../shared/components/video-modal/video-modal.component';
import { StorageService } from '../../../shared/services/storage.service';
import { catchError, of } from 'rxjs';

@Component({
  selector: 'app-testimonial-section',
  standalone: true,
  imports: [ApplyButtonComponent, MatDialogModule],
  templateUrl: './testimonial-section.component.html',
  styleUrls: ['./testimonial-section.component.scss']
})
export class TestimonialSectionComponent implements OnInit {
  johnVideoUrl: string | null = null;

  constructor(private dialog: MatDialog, private storageService: StorageService) {}

  ngOnInit(): void {
    this.storageService.getVideoUrl('testimonials/videos/john.mov')
      .pipe(catchError(() => of(null)))
      .subscribe(url => this.johnVideoUrl = url);
  }

  openVideo(name: string, videoKey: 'john', event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    const videoUrl = this.johnVideoUrl;
    if (!videoUrl) {
      // Show loading modal if not loaded yet
      this.dialog.open(VideoModalComponent, {
        width: '800px',
        maxWidth: '95vw',
        maxHeight: '90vh',
        panelClass: 'video-modal-dialog',
        data: {
          videoUrl: '',
          title: name,
          isLoading: true
        }
      });
      return;
    }
    this.dialog.open(VideoModalComponent, {
      width: '800px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      panelClass: 'video-modal-dialog',
      data: {
        videoUrl,
        title: name
      }
    });
  }
} 